var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{class:[
        'container d-flex justify-content-between py-4',
        _vm.isShortPage ? 'text-white' : '' ]},[_vm._m(0),_c('div',{staticClass:"copyright pull-right"},[_vm._v("© "+_vm._s(_vm.year)+", Attis")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"pull-left"},[_c('ul')])}]

export { render, staticRenderFns }